// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Search: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15">
            <path
                fill="currentColor"
                d="M13.78399,12.8789062 L10.1199275,9.21484375 C10.9128962,8.24414062 11.3503962,7.02187467 11.3503962,5.6875 C11.3503962,2.54570329 8.80387264,0 5.66289622,0 C2.52191979,0 0,2.54652357 0,5.6875 C0,8.82847643 2.54625571,11.375 5.66289663,11.375 C6.99699843,11.375 8.22090495,10.9126171 9.19024038,10.1434373 L12.8543029,13.8074998 C13.0074281,13.9371097 13.1769588,14 13.3437558,14 C13.5105529,14 13.6795371,13.9359064 13.8077793,13.8077459 C14.0628961,13.5515627 14.0628961,13.1359373 13.7839904,12.8789062 L13.78399,12.8789062 Z M1.31250584,5.6875 C1.31250584,3.27523434 3.27524018,1.3125 5.68750584,1.3125 C8.0997715,1.3125 10.0625058,3.27523434 10.0625058,5.6875 C10.0625058,8.09976566 8.0997715,10.0625 5.68750584,10.0625 C3.27524018,10.0625 1.31250584,8.09921908 1.31250584,5.6875 Z"
                transform="translate(0 .75)"
            />
        </svg>
    );
};

export default React.memo(Search);
